import React from 'react';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  borderRadius?: string;
  style?: React.CSSProperties;
}

export function Skeleton({ width = '100%', height = '1rem', borderRadius = 'var(--radius-interactive)', style }: SkeletonProps) {
  return (
    <div
      className="skeleton"
      style={{ width, height, borderRadius, ...style }}
    />
  );
}

export function SkeletonCard() {
  return (
    <div style={{
      background: 'var(--glass-bg-card)',
      border: '1px solid rgba(255,255,255,0.10)',
      borderRadius: 'var(--radius-card)',
      padding: '1.25rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.75rem',
    }}>
      <Skeleton height="1.25rem" width="60%" />
      <Skeleton height="0.875rem" width="40%" />
      <Skeleton height="0.875rem" width="80%" />
    </div>
  );
}

export function SkeletonRow() {
  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: '2fr 1fr 1fr 1fr',
      gap: '1rem',
      padding: '0.75rem 1rem',
      alignItems: 'center',
    }}>
      <Skeleton height="0.875rem" />
      <Skeleton height="0.875rem" />
      <Skeleton height="0.875rem" />
      <Skeleton height="0.875rem" />
    </div>
  );
}
